module.exports = __webpack_public_path__ + "img/report-icon.326139a7.svg";